export default "__VITE_ASSET__Cuz4qmpB__"